import type { SafeString } from '@ember/template';
import { tracked } from '@glimmer/tracking';

import type PopupWrapperModalComponent from 'webapp/components/popup/wrapper/modal';

import type { PopupProps } from 'webapp/models-custom/popup/base';
import PopupBase from 'webapp/models-custom/popup/base';

// Modal popup v3

export interface PopupModalProps extends PopupProps {
	skipFrame?: boolean;
	showClose?: boolean;
	isAutoCentered?: boolean;
	elementToAnimateFrom?: HTMLElement;
}

export default class PopupModal extends PopupBase {
	override component: PopupWrapperModalComponent | null = null;

	skipFrame = false;
	showClose = true;
	isAutoCentered = true;
	elementToAnimateFrom: HTMLElement | null = null; // The HTML element to use as the origin point for animation

	// in some cases, isAutoCentered is false, so positoning is done manually
	// this popup style is explicitly set from outside (e.g. modal/board preview popups)
	@tracked popupStyle: string | SafeString = '';

	constructor(props: PopupModalProps) {
		super(props);

		if (typeof props.skipFrame !== 'undefined') {
			this.skipFrame = props.skipFrame;
		}

		if (typeof props.showClose !== 'undefined') {
			this.showClose = props.showClose;
		}

		if (typeof props.isAutoCentered !== 'undefined') {
			this.isAutoCentered = props.isAutoCentered;
		}

		if (typeof props.elementToAnimateFrom !== 'undefined') {
			this.elementToAnimateFrom = props.elementToAnimateFrom;
		}

		// for modal, these are true by default
		this.closeOnOverlayClick = props.closeOnOverlayClick ?? true;
		this.hasOverlay = props.hasOverlay ?? true;
	}

	override get isModal(): boolean {
		return true;
	}
}
